// 1st Party
import { quote } from './elements';

var delay = 10000;

quote.products.on('click', (e) => {
    e.preventDefault();
    let itemName = $(e.currentTarget).find('.wm-quote-box__product-item-name').text().trim();
    recordProductEvent(itemName);
});

quote.mobileProducts.on('change', (e) => {
    let itemName = $(e.currentTarget).find(':selected').text().trim();
    recordProductEvent(itemName);
});

inputTimeout(quote.property.fullAddress, () => {
    recordEvent('PropertyAddress', 'Address', 1);
});

inputTimeout(quote.property.unitNumber, () => {
    recordEvent('PropertyAddress', 'Unit', 1);
});

quote.newPurchase.on('click', (e) => {
    if ($(e.currentTarget).val() === 'true') {
        recordEvent('IsNewAddress', 'Yes', 1);
    } else {
        recordEvent('IsNewAddress', 'No', 1);
    }
});

quote.button.on('click', (e) => {
    e.preventDefault();
    recordEvent('GetStartedButton', 'Clicked', 1);
});

quote.buttonExit.on('click', (e) => {
    recordEvent('BackButton', 'Clicked', 1);
});

inputTimeout(quote.firstName, () => {
    recordEvent('InsuredName', 'FirstName', 1);
});

inputTimeout(quote.middleName, () => {
    recordEvent('InsuredName', 'MiddleName', 1);
});

inputTimeout(quote.lastName, () => {
    recordEvent('InsuredName', 'LastName', 1);
});

inputTimeout(quote.emailAddress, () => {
    recordEvent('InsuredEmail', 'Email', 1);
});

inputTimeout(quote.phoneNumber, () => {
    recordEvent('InsuredPhone', 'Phone', 1);
});

inputTimeout(quote.mailing.fullAddress, () => {
    recordEvent('InsuredAddress', 'Address', 1);
});

inputTimeout(quote.mailing.unitNumber, () => {
    recordEvent('InsuredAddress', 'Unit', 1);
});

quote.sameAddress.on('change', (e) => {
    let checked = $(e.currentTarget).prop('checked');
    if (checked) {
        recordEvent('IsSameAsProperty', 'Yes', 1);
    }
});

quote.buttonSubmit.on('click', () => {
    if (quote.form.valid()) {
        recordEvent('GetQuoteButton', 'Clicked', 1);
    }
});

// Espanol

inputTimeout(quote.espanolEmail.fullAddress, () => {
    recordEvent('EspanolPropertyAddress', 'Address', 1);
});

inputTimeout(quote.espanolEmail.unitNumber, () => {
    recordEvent('EspanolPropertyAddress', 'Unit', 1);
});

quote.espanolEmail.occupancy.on('change', (e) => {
    let itemValue = $(e.currentTarget).find(':selected').data('value').trim();
    recordEspanolProductEvent(itemValue);
});

inputTimeout(quote.espanolEmail.firstName, () => {
    recordEvent('EspanolInsuredName', 'FirstName', 1);
});

inputTimeout(quote.espanolEmail.lastName, () => {
    recordEvent('EspanolInsuredName', 'LastName', 1);
});

inputTimeout(quote.espanolEmail.emailAddress, () => {
    recordEvent('EspanolInsuredEmail', 'Email', 1);
});

inputTimeout(quote.espanolEmail.phoneNumber, () => {
    recordEvent('EspanolInsuredPhone', 'Phone', 1);
});

quote.espanolEmail.newPurchase.on('change', (e) => {
    let itemValue = $(e.currentTarget).find(':selected').val().trim();
    if (itemValue === 'true') {
        recordEvent('EspanolNewPurchase', 'true', 1);
    } else if (itemValue === 'false') {
        recordEvent('EspanolNewPurchase', 'false', 1);
    } else {
        recordEvent('EspanolNewPurchase', 'blank', 1);
    }
});

quote.espanolEmail.buttonSubmit.on('click', (e) => {
    if (quote.espanolForm.valid()) {
        recordEvent('EspanolSubmitQuote', 'Clicked', 1);
    }
});

//

function inputTimeout(element, callback) {
    var timeout;
    element.on('keyup', function (e) {
        if (timeout) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(function () {
            callback();
        }, delay);
    });
}

function recordProductEvent(productName) {
    switch (productName) {
        case 'Homeowners':
            recordEvent('Product', 'H3', 1);
            break;
        case 'Condo':
            recordEvent('Product', 'H6', 1);
            break;
        case 'Landlord':
            recordEvent('Product', 'DF', 1);
            break;
        case 'Seasonal':
            recordEvent('Product', 'H3S', 1);
            break;
    }
}

function recordEspanolProductEvent(productName) {
    switch (productName) {
        case 'Homeowners':
            recordEvent('EspanolProduct', 'H3', 1);
            break;
        case 'Condo':
            recordEvent('EspanolProduct', 'H6', 1);
            break;
        case 'Landlord':
            recordEvent('EspanolProduct', 'DF', 1);
            break;
        case 'Seasonal':
            recordEvent('EspanolProduct', 'H3S', 1);
            break;
        case 'Vacant':
            recordEvent('EspanolProduct', 'VA', 1);
            break;
    }
}

function recordEvent(category, action, value) {
    //console.log(category, action, value);

    if (window.ga) {
        window.ga('send', {
            hitType: 'event',
            eventCategory: category,
            eventAction: action,
            eventValue: value
        });
    }

    if (window.gtag) {
        window.gtag('event', 'generate_lead', {
            'event_category': category,
            'event_action': action,
            'event_value': value
        });
    }
}